import height from '../utils/document-height';

var strategy = function(point){
    
    var regex = /\d{1,3}(?=\s*%)/;
    
    if (typeof(point) === 'string' && regex.test(point)) {
        point = height() * parseInt(point.match(regex)[0]) / 100;
    }

    return new Promise(function(resolve, reject){
        if (!!point) {
            window.addEventListener('scroll', handler);
        } else {
            resolve();
        }
        
        function handler(ev){
            if (window.pageYOffset >= point) {
                resolve();
            }
        }
    });
}

export default strategy;


//////////////////
// WEBPACK FOOTER
// ./src/strategies/screen-point-reached.js
// module id = 9
// module chunks = 0